module.exports = __webpack_public_path__ + "cert_3.png?05fbb83de1914bbe9362711f4505135a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert_3.png
// module id = 33
// module chunks = 0